// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"316":"0515952d","407":"52b27740","485":"c4cc539b","719":"0af28cbc","954":"9d531a54"}[chunkId] + ".css";
};